export enum SocialLogin {
  Kakao = 'kakao',
  Naver = 'naver',
  Google = 'google',
  Facebook = 'facebook',
  Firebase = 'firebase',
  Line = 'line',
}

export enum PixcelsLoginProvider {
  MagicLink = 'magiclink',
  License = 'picense',
  Piperks = 'piperks',
}
